import { TAuthOptions, TStepTextOverrides } from 'src/hooks/use-auth/useAuth.types';

export enum AuthType {
  AUTH = 'auth',
  AUTH_WITH_GOOGLE_ONE_TAP = 'auth_with_google_one_tap',
}

export type AuthComponentProps = {
  type: AuthType;
  afterCompletedAuthentication: () => void;
  startingStep?: TAuthOptions['startingStep'];
  stepTextOverrides?: TStepTextOverrides;
};
